import { customFetch, AuthClient, decodeToken } from '@skytech/auth'
import { config } from '@skytech/config'
import { convertToCamelCase } from '@skytech/utils'

import type { Profile, TokenData } from '@/app/types'
import { get } from '@/util/auth'
import getUserFromToken from '@/util/getUserFromToken'

const IS_NEW_BACKEND_API = true

const userResources = {
  get: async () => {
    const res = await customFetch<{ token: string }>({
      path: 'manager/token',
      environment: config.AUTH_API_URL,
      credentials: 'include',
    })

    const tokenData: TokenData = decodeToken(res.token)
    const user = getUserFromToken(tokenData)
    AuthClient.setToken(res.token)

    return user
  },
  getProfile: async () => {
    const profile = await get<Profile>('auth/profile', IS_NEW_BACKEND_API)
    const parsedProfile = convertToCamelCase(profile)

    return parsedProfile as Profile
  },
}

export default userResources
